import PaymentBase from "./components/Base";

export default function PaymentFeature() {
  return (
    <div className="relative">
      <PaymentBase />
    </div>
  );
}
